import { Box, Button } from '@mui/material';
import { InlineLoader } from '../../components/InlineLoader';

type Props = {
  label: string;
  loading: boolean;
  onLoadMore: () => void;
};

export const LoadMore = ({ loading, onLoadMore, label }: Props) => {
  return (
    <Box sx={{ backgroundColor: 'grey.100', textAlign: 'center' }}>
      {loading ? (
        <InlineLoader size={21} color="text.disabled" py={2} />
      ) : (
        <Button sx={{ textTransform: 'none', color: 'text.primary', borderRadius: 0, width: '100%', py: 1.75 }} variant="text" onClick={() => onLoadMore()}>
          {label}
        </Button>
      )}
    </Box>
  );
};
